import { detect } from 'detect-browser';
import { handleActions } from 'redux-actions';
const browser = detect();
const initialState = {
    browser: browser,
};
export const keyboardShortcuts = handleActions({}, initialState);
